import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchData, postFormData } from "../../../redux/apiSlice";
import { Box, Card, CardContent, Typography, Grid, IconButton } from "@mui/material";
import Freez from '../../../Components/Loader/Loader'
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";

const SavedTemplates = () => {
    const [savedEmails, setSavedEmails] = useState([]);
    const dispatch = useDispatch();
    const [freez, setFreez] = React.useState(false);
    const navigate = useNavigate();
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };

    useEffect(() => {
        const fetchSavedEmails = async () => {
            let token = localStorage.getItem("token");
            if (!token) {
                console.error("No token found");
                return;
            }
            handleFreezStart();
            const apiUrl = "/template/all";
            try {
                const res = await dispatch(fetchData(apiUrl)).unwrap();
                if (res && res.success === true) {
                    setSavedEmails(res.data);
                } else {
                    console.error("Something went wrong!");
                }
            } catch (error) {
                console.error("Error fetching saved emails:", error);
            } finally {
                handleFreezStop();
            }
        };
        fetchSavedEmails();
    }, [dispatch]);
    const ContentLayout =
        <>
            <Box sx={{ padding: 1 }}>
                <IconButton onClick={() => navigate(-1)} sx={{ mb: 2 }}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Saved Templates
                </Typography>
                <Grid container spacing={2}>
                    {savedEmails.slice(0, 8).map((email) => (
                        <Grid item xs={12} sm={4} md={3} key={email.id}>
                            <Card
                                variant="outlined"
                                sx={{
                                    width: "100%",
                                    height: 320,
                                    borderRadius: 2,
                                    border: "1px solid #BEBABA", cursor: "pointer",
                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)"
                                }}
                                onClick={() => navigate("/email-editor", { state: { content: email.content } })}
                            >
                                <CardContent sx={{ flexGrow: 1, width: "100%", textAlign: "center", padding: "8px 0" }}>
                                    <Typography
                                        variant="body2"
                                        sx={{ fontSize: 12, color: "text.secondary", wordWrap: "break-word" }}
                                        dangerouslySetInnerHTML={{ __html: email.content }}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                    onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div></>
    );
};

export default SavedTemplates;